export const COOKIE_FLARE_ANONYMOUS_ID_CONFIG = {
  name: "flare-anonymous-uuid",
  options: {
    path: "/",
    sameSite: "lax" as const,
    secure: true,
  },
};
